<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0" stepTitle="房型/价格计划"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基础信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品标题" prop="proName">
              <a-input v-model="ruleForm.proName" :maxLength="120" placeholder="建议填写酒店名称">
                <span slot="addonAfter">{{ ruleForm.proName.length }}/120</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="介绍标语" prop="proTitle">
              <a-textarea v-model="ruleForm.proTitle" :maxLength="200" placeholder="请输入"
                          :auto-size="{ minRows: 3, maxRows: 5 }"/>
            </a-form-model-item>
            <a-form-model-item label="所在地区" prop="areaList">
              <AreaSelected
                v-model="ruleForm.areaList"
                :areaStyle="{'width':'400px'}"
                area-type="all"
                :changeOnSelect="false"
                @change="onCityChange"
              ></AreaSelected>
              <!--              <AreaKinkage-->
              <!--                v-model="ruleForm.areaList"-->
              <!--                ref="areaData"-->
              <!--                @getAreaData="getAreaData" maxWidth="600px"></AreaKinkage>-->
            </a-form-model-item>
            <a-form-model-item label="详细地址" prop="proAddress">
              <a-input v-model="ruleForm.proAddress" @blur="onBlurAddress" :maxLength="80"
                       placeholder="请输入详细地址"></a-input>
            </a-form-model-item>
            <!-- style="display:inline-block;" -->
            <a-form-model-item label="经纬度" required style="margin-bottom:0;">
              <a-row :gutter="20">
                <a-col :span="8">
                  <a-form-model-item prop="proLongitude">
                    <a-input v-model="ruleForm.proLongitude" :maxLength="80" placeholder="请选择经度"
                             :disabled="true"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item prop="proLatitude">
                    <a-input v-model="ruleForm.proLatitude" :maxLength="80" placeholder="请选择纬度"
                             :disabled="true"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-button @click="showMapEvent">选择</a-button>
                </a-col>
              </a-row>
            </a-form-model-item>
            <a-form-model-item label="所属商圈">
              <a-select show-search :filter-option="filterOption" v-model="ruleForm.hotelBusinessRing" allowClear
                        placeholder="请选择" style="max-width:600px;">
                <a-select-option v-for="item in hotelProBusiness" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="酒店电话">
              <a-input v-model="ruleForm.hotelPhone" :maxLength="50" placeholder="请输入酒店电话"></a-input>
            </a-form-model-item>
            <a-form-model-item label="酒店设施">
              <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选
              </a-checkbox>
              <a-checkbox-group v-model="ruleForm.hotelFacility" @change="onChange">
                <a-checkbox v-for="item in plainOptions" :key="item.code" :value="item.code">{{ item.name }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item label="开业时间">
              <a-date-picker v-model="hotelOpenTime" @change="onDateChange"/>
            </a-form-model-item>
            <a-form-model-item label="入离店时间" required style="margin-bottom:0;">
              <a-row :gutter="16">
                <a-col style="display:inline-block;max-width:250px;">
                  <a-form-model-item>
                    <a-time-picker :allowClear="false" v-model="inTime" @change="onChangeInTime" format="HH:mm"/>
                  </a-form-model-item>
                </a-col>
                <a-col style="display:inline-block;max-width:250px;">
                  <a-form-model-item>
                    <a-time-picker :allowClear="false" v-model="outTime" @change="onChangeOutTime" format="HH:mm"/>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model-item>
            <a-form-model-item label="酒店类型">
              <a-select
                v-model="hotelBindTypes"
                mode="multiple"
                placeholder="请选择"
                option-label-prop="label"
                style="max-width:600px;"
                @change="handleTypeChange"
              >
                <a-select-option v-for="item in hotelTypeList" :key="item.code" :value="item.code" :label="item.name">
                  <span role="img" :aria-label="item.name">{{ item.name }}</span>
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="酒店主题">
              <a-select
                v-model="hotelBindThemes"
                mode="multiple"
                placeholder="请选择"
                option-label-prop="label"
                style="max-width:600px;"
                @change="handleThemeChange"
              >
                <a-select-option v-for="item in hotelThemeList" :key="item.code" :value="item.code" :label="item.name">
                  <span role="img" :aria-label="item.name">{{ item.name }}</span>
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="酒店星级">
              <a-select v-model="ruleForm.hotelGrade" allowClear placeholder="请选择" style="max-width:600px;">
                <a-select-option v-for="item in hotelGradeList" :key="item.code" :value="item.code">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="酒店品牌">
              <a-cascader allowClear
                          :options="hotelBrandList"
                          :value='defaultWayValue'
                          changeOnSelect placeholder="请选择"
                          @change="onHotelBrandChange" style="max-width:600px;"/>
            </a-form-model-item>
            <a-form-model-item label="商品轮播图" prop="proImgs">
              <custom-upload-pro-images v-model="ruleForm.proImgs"
                                        :pro-id="proId" :multiple-selected="true"
                                        :draggableUpdate="true">
              </custom-upload-pro-images>
            </a-form-model-item>
            <a-form-model-item label="图文详情" required>
              <CustomUeditor v-model="ruleForm.proDes"></CustomUeditor>
            </a-form-model-item>
            <a-form-model-item label="预订须知">
              <a-textarea v-model="ruleForm.hotelBookingNeed" :maxLength="1500" placeholder="请输入"
                          :auto-size="{ minRows: 8, maxRows: 15 }"/>
            </a-form-model-item>
            <!--            <a-form-model-item label="备注">-->
            <!--              <a-textarea v-model="ruleForm.hotelRemark" :maxLength="500" placeholder="请输入" :auto-size="{ minRows: 5, maxRows: 10 }"/>-->
            <!--            </a-form-model-item>-->
            <a-form-model-item label="发票模板" prop="invoiceTemplateId">
              <InvoiceSelect ref="InvoiceSelect" :proId="proId" :catalogId="catalogId"
                             v-model="ruleForm.invoiceTemplateId"></InvoiceSelect>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>

      </div>
    </div>
    <!-- 百度地图 -->
    <MapLocationPicker
      v-if="showMap"
      :visible.sync="showMap"
      :default-lat="ruleForm.proLatitude"
      :defaultLng="ruleForm.proLongitude"
      @confirm="mapConfirmEvent"
    ></MapLocationPicker>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import AreaKinkage from '@/customComponents/AreaKinkage/AreaKinkage'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'
import InvoiceSelect from '../components/InvoiceSelect'
import MapLocationPicker from '@/customComponents/MapLocationPicker/index.vue'
import AreaSelected from '@/customComponents/AreaSelected/AreaSelected'
import moment from 'moment'
import { getLatAndLng, parserAddress } from '@/utils/helper/TianDiTuHelper'

export default {
  name: 'HotelBasicInfo',
  components: {
    ProductHeader,
    MapLocationPicker,
    PublishHelper,
    AreaKinkage,
    CustomUploadProImages,
    CustomUeditor,
    InvoiceSelect,
    AreaSelected
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      showMap: false,
      moment,
      inTime: moment('14:00', 'HH:mm'), //酒店入住时间 提交时删除
      outTime: moment('12:00', 'HH:mm'), //酒店离开时间 提交时删除
      ruleForm: {
        proName: '', //酒店名称
        proTitle: '', //介绍标语
        proAddress: '', //详细地址
        proProvinceId: '', //省ID
        proCityId: '', //市ID
        proCountyId: '', //县ID
        proId: this.$route.query.proId, //产品ID
        proDes: '', //酒店介绍
        hotelInTime: '14:00', //酒店入住时间
        hotelOutTime: '12:00', //酒店离开时间
        hotelPhone: '', //酒店电话
        hotelOpenTime: '', //开业时间
        hotelNewDecorateDate: '', //酒店装修时间
        hotelBookingNeed: '', //酒店预订须知
        hotelRemark: '', //酒店备注
        hotelFacility: [], //酒店设施
        proLongitude: '', //经度
        proLatitude: '', //纬度
        proImgs: [], //提交图片字符串
        hotelTypes: '',//酒店类型
        hotelThemes: '',//酒店主题
        hotelGrade: undefined,//酒店星级
        hotelBrandName: '',//酒店品牌类别名称
        hotelBrandCategory: '',//酒店品牌类别
        hotelBusinessRing: undefined,//所属商圈
        areaList: undefined,//提交时删除
        invoiceTemplateId: undefined//发票
      },
      submitLoading: false,
      submitFormData: {},
      hotelBrandList: [],//品牌
      hotelTypeList: [],//类型
      hotelGradeList: [],//星级
      hotelThemeList: [],//主题
      hotelBrandNameList: [],//酒店品牌名称集合
      hotelProBusiness: [],//酒店商圈集合
      invoiceTemplateList: [],
      invoiceTemplateId: '',//发票ID
      rules: {
        proName: [
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        proTitle: [
          { required: true, message: '请输入介绍标语', trigger: 'blur' }
        ],
        areaList: [
          { required: true, message: '请选择所在地区', trigger: 'change' }
        ],
        proAddress: [
          { required: true, message: '请输入酒店详细地址', trigger: 'blur' }
        ],
        proLongitude: [
          { required: true, message: '请输入经度', trigger: 'blur' },
          {
            pattern: /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,20})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,20}|180)$/,
            message: '经度整数部分为0-180,小数部分最长20位',
            trigger: 'blur'
          }
        ],
        proLatitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' },
          {
            pattern: /^(\-|\+)?([0-8]?\d{1}\.\d{0,20}|90\.0{0,20}|[0-8]?\d{1}|90)$/,
            message: '纬度整数部分为0-90,小数部分最长20位',
            trigger: 'blur'
          }
        ],
        proImgs: [
          { required: true, message: '请选择图片', trigger: ['blur', 'change'] }
        ],
        invoiceTemplateId: [
          { required: true, message: '请选择发票模板', trigger: 'change' }
        ]
      },
      plainOptions: [],
      indeterminate: false,
      checkAll: false,
      checkedIdList: [],
      hotelOpenTime: undefined,
      hotelBindTypes: [],
      hotelBindThemes: [],
      defaultWayValue: [],
      selectedOptions: []
    }
  },
  mounted() {
    this.getHotelRelatedEnum()
    this.getProHotelBrand()
    this.getHotelInfo()
  },
  methods: {
    onCityChange(item) {
      this.ruleForm.areaList = item.value
      if (item.value && item.value.length > 0) {
        if (item.value[0] == 0) {
          this.ruleForm.countryId = ''
          this.ruleForm.countryName = ''
          this.ruleForm.proCityId = null
          this.ruleForm.cityName = null

          this.ruleForm.proProvinceId = item.value[1]
          this.ruleForm.proCityId = item.value[2]
          this.ruleForm.proCountyId = item.value[3]
          this.getProHotelBusiness(item.value[2], item.value[3])
        } else {
          this.hotelProBusiness = []
          this.ruleForm.proProvinceId = null
          this.ruleForm.proCityId = null
          this.ruleForm.proCountyId = null

          this.ruleForm.countryId = item.value[1]
          this.ruleForm.countryName = item.selectedOptions[1].label
          this.ruleForm.proCityId = item.value[2]
          this.ruleForm.cityName = item.selectedOptions[2].label
        }
      }
      this.selectedOptions = item.selectedOptions ? item.selectedOptions : []
    },
    // 获取城市id
    getAreaData(data) {
      this.ruleForm.areaList = data
      if (data && data.length > 0) {
        this.ruleForm.proProvinceId = data[0]
        this.ruleForm.proCityId = data[1]
        this.ruleForm.proCountyId = data[2]
        this.getProHotelBusiness(data[1], data[2])
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onChangeInTime(time, timeStr) {
      this.getLogUtils().logWithTag('onChangeInTime', time)
      this.getLogUtils().logWithTag('onChangeInTime', timeStr)
      this.inTime = time
      this.ruleForm.hotelInTime = timeStr //酒店入住时间
    },
    onChangeOutTime(time, timeStr) {
      this.getLogUtils().logWithTag('onChangeOutTime', time)
      this.getLogUtils().logWithTag('onChangeOutTime', timeStr)
      this.outTime = time
      this.ruleForm.hotelOutTime = timeStr//酒店离开时间
    },
    onDateChange(date, dateString) {
      this.hotelOpenTime = date
      this.ruleForm.hotelOpenTime = dateString
      this.getLogUtils().logWithTag('onDateChange', this.ruleForm.hotelOpenTime)
    },
    handleTypeChange(value) {
      this.getLogUtils().logWithTag('handleTypeChange', value)
      if (value && value.length > 0) {
        this.ruleForm.hotelTypes = value.join(',')
      } else {
        this.ruleForm.hotelTypes = ''
      }
      this.getLogUtils().logWithTag('handleTypeChange', this.ruleForm.hotelTypes)
    },
    handleThemeChange(value) {
      this.getLogUtils().logWithTag('handleTypeChange', value)
      if (value && value.length > 0) {
        this.ruleForm.hotelThemes = value.join(',')
      } else {
        this.ruleForm.hotelThemes = ''
      }
      this.getLogUtils().logWithTag('handleTypeChange', this.ruleForm.hotelThemes)
    },
    // 获取领取方式
    onHotelBrandChange(value, selectedOptions) {
      this.getLogUtils().logWithTag('handleTypeChange', value)
      if (value && value.length) {
        this.defaultWayValue = [value[0], value[1]]
        this.ruleForm.hotelBrandCategory = value[0]//酒店品牌类别
        this.ruleForm.hotelBrandName = value[1]//酒店品牌类别名称
      } else {
        this.defaultWayValue = []
        this.ruleForm.hotelBrandCategory = ''
        this.ruleForm.hotelBrandName = ''
      }
    },
    showMapEvent() {
      this.showMap = true
    },
    mapConfirmEvent(location) {
      this.getLogUtils().logWithTag('mapConfirmEvent', location)
      this.showMap = false
      this.ruleForm.proLongitude = location.lng
      this.ruleForm.proLatitude = location.lat
    },
    cancelShowMap() {
      this.showMap = false
    },
    checkForm() {
      if (!this.ruleForm.proDes) {
        this.$message.error('请输入图文详情')
        return false
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            if (this.ruleForm.areaList[0] == 0) {
              this.getLongitude(true)
            } else {
              this.submitData()
            }
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      // this.submitLoading = true;
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      if (this.submitFormData.hotelFacility && this.submitFormData.hotelFacility.length > 0) {
        this.submitFormData.hotelFacility = this.submitFormData.hotelFacility.join(',')
      } else {
        this.submitFormData.hotelFacility = ''
      }
      this.submitFormData.proImgs = this.submitFormData.proImgs.length > 0 ? this.submitFormData.proImgs.join(',') : ''
      delete this.submitFormData.areaList
      this.getHttpServices().getProService().post('product/hotel/editProHotel', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('酒店基本信息保存成功')
        this.ruleForm.proId = res
        this.$router.push({
          name: 'HotelBookSet',
          query: {
            proId: this.ruleForm.proId,
            catalogId: this.catalogId,
            proSource: this.proSource,
            isBack: this.proId == 0 ? 1 : undefined
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //获取经纬度
    getBaiDuLatAndLng() {
      return new Promise((resolve, reject) => {
        // let parms = {
        //   address:this.ruleForm.proAddress,
        //   cityId: this.ruleForm.proCityId?this.ruleForm.proCityId:0,
        //   countyId:this.ruleForm.proCountyId?this.ruleForm.proCountyId:0,
        //   provinceId:this.ruleForm.proProvinceId?this.ruleForm.proProvinceId:0
        // }
        // this.getHttpServices().getProService().post('public/getBaiDuLatAndLng', parms)
        const realAddress = parserAddress(this.selectedOptions, this.ruleForm.proAddress)
        getLatAndLng(this, realAddress)
          .then(res => {
            this.getLogUtils().logWithTag('getBaiDuLatAndLng', res)
            resolve(res)
          }).catch(reason => {
          reject(reason)
          this.showNetWorkErrorMessage(reason)
        })
      })
    },
    onBlurAddress() {
      if (this.selectedOptions.length > 0 && !this.ruleForm.proLongitude) {
        this.getLongitude(false)
      }
    },
    getLongitude(flag) {
      this.getBaiDuLatAndLng().then(res => {
        if (res.lng && res.lat) {
          this.ruleForm.proLongitude = res.lng//经度
          this.ruleForm.proLatitude = res.lat//纬度
        }
      }).catch(err => this.showNetWorkErrorMessage(err)).finally(() => {
        if (flag) {//调保存接口
          this.submitData()
        }
      })
    },
    //获取商圈信息
    getProHotelBusiness(cityId, countyId) {
      this.getHttpServices().getProService().get('product/hotel/getProHotelBusiness?cityId=' + cityId + '&countyId=' + countyId).then(res => {
        this.getLogUtils().logWithTag('getProHotelBusiness', res)
        this.hotelProBusiness = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onChange(checkedList) {
      this.getLogUtils().logWithTag('onChange===', checkedList)
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    onCheckAllChange(e) {
      this.getLogUtils().logWithTag('onCheckAllChange===', e)
      this.ruleForm.hotelFacility = e.target.checked ? this.checkedIdList : []
      this.checkAll = e.target.checked
      this.indeterminate = false
      this.getLogUtils().logWithTag('数据===', this.ruleForm.hotelFacility)
    },
    //获取酒店设施+获取酒店的酒店主题+酒店星级的等等
    getHotelRelatedEnum() {
      this.getHttpServices().getBaseService().get('base/sysCode/getHotelRelatedEnum').then(res => {
        this.getLogUtils().logWithTag('getHotelRelatedEnum', res)
        this.plainOptions = res.facility
        let arr = []
        this.plainOptions.forEach(item => {
          arr.push(item.code)
        })
        this.checkedIdList = arr
        this.hotelTypeList = res.hotelType//类型
        this.hotelGradeList = res.hotelGrade //星级
        this.hotelThemeList = res.hotelTheme//主题
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取酒店品牌
    getProHotelBrand() {
      this.getHttpServices().getProService().get('product/hotel/getProHotelBrand').then(res => {
        this.getLogUtils().logWithTag('getProHotelBrand', res)
        this.hotelBrandList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取酒店基本信息
    getHotelInfo() {
      if (this.proId != 0) {
        this.getHttpServices().getProService().get('product/hotel/getProHotelInfo?proId=' + this.proId).then(res => {
          this.getLogUtils().logWithTag('getHotelInfo', res)
          this.ruleForm = res
          this.inTime = res.hotelInTime ? moment(res.hotelInTime, 'HH:mm') : moment('14:00', 'HH:mm')
          this.outTime = res.hotelOutTime ? moment(res.hotelOutTime, 'HH:mm') : moment('12:00', 'HH:mm')
          this.hotelOpenTime = res.hotelOpenTime ? moment(res.hotelOpenTime, 'YYYY-MM-DD') : undefined
          this.ruleForm.hotelBusinessRing = res.hotelBusinessRing ? res.hotelBusinessRing : undefined
          this.ruleForm.hotelGrade = res.hotelGrade ? res.hotelGrade : undefined
          if (res.proProvinceId && res.proCityId && !res.proCountyId) {
            this.ruleForm.areaList = [0, res.proProvinceId, res.proCityId]
            // this.$refs.areaData.getArea(this.ruleForm.areaList)
          }
          if (res.proProvinceId && res.proCityId && res.proCountyId) {
            this.ruleForm.areaList = [0, res.proProvinceId, res.proCityId, res.proCountyId]
            // this.$refs.areaData.getArea(this.ruleForm.areaList)
            this.getProHotelBusiness(res.proCityId, res.proCountyId)
          }
          if (res.proCountryId && res.proCityId) {
            this.ruleForm.areaList = [1, res.proCountryId, res.proCityId]
          }
          if (res.hotelFacility && res.hotelFacility != '') {
            this.ruleForm.hotelFacility = res.hotelFacility.split(',') //酒店设施

            this.ruleForm.hotelFacility = this.ruleForm.hotelFacility.map(value => {
              return parseInt(value)
            })
            if (this.plainOptions.length == this.ruleForm.hotelFacility.length) {
              this.indeterminate = false
              this.checkAll = true
            } else {
              this.indeterminate = true
              this.checkAll = false
            }
          } else {
            this.ruleForm.hotelFacility = []
            this.indeterminate = false
            this.checkAll = false
          }
          if (res.hotelTypes) {
            this.hotelBindTypes = res.hotelTypes.split(',')
            this.hotelBindTypes = this.hotelBindTypes.map(value => {
              return parseInt(value)
            })
          }
          if (res.hotelThemes) {
            this.hotelBindThemes = res.hotelThemes.split(',')
            this.hotelBindThemes = this.hotelBindThemes.map(value => {
              return parseInt(value)
            })
          }
          if (res.hotelBrandCategory && res.hotelBrandName) {
            this.defaultWayValue = [res.hotelBrandCategory, res.hotelBrandName]
          }
          this.ruleForm.proImgs = res.proImgs && res.proImgs != '' ? res.proImgs.split(',') : []
          this.$refs.InvoiceSelect.getMatchTemplateId()
          this.getLogUtils().logWithTag('getHotelInfo', this.ruleForm)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>